import { render, staticRenderFns } from "./Escaneados.vue?vue&type=template&id=6d510f4c"
import script from "./Escaneados.vue?vue&type=script&lang=js"
export * from "./Escaneados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports